import { gql } from '@apollo/client'

export default gql(`
    mutation adminTerminateSubscription($email: String!, $id: ID! $project: String) {
        adminTerminateSubscription(
            email: $email
            id: $id
            project: $project
        ) {
            success{
                message
            }
            error{
                message
            }
            data {
                activatedAt
                createdAt
                customerId
                endDate
                id
                planId
                price
                renewalDate
                status
                planData {
                  description
                  id
                  interval
                  name
                  price
                  provider {
                    id
                    name
                  }
                  providerId
                }
            }
        }
    }`
)
